import React from 'react'
import injecaoPlastico from "../../imagens/injecaoPlastico/injecaoPlastico.jpeg"
import injecaoPlastico2 from "../../imagens/injecaoPlastico/injecaoPlastico2.jpeg"
import injecaoPlastico4 from "../../imagens/injecaoPlastico/injecaoPlastico4.jpeg"
import injecaoPlastico5 from "../../imagens/injecaoPlastico/injecaoPlastico5.jpeg"
import injecaoPlastico6 from "../../imagens/injecaoPlastico/injecaoPlastico6.jpeg"
import Header from '../../Components/Header'
import ImgInjecaoPlastico from '../../Components/injecaoPlastico'


const listaInjecaoPlastico = [
    {
        img: injecaoPlastico
    },
    {
        img: injecaoPlastico2
    },
    {
        img: injecaoPlastico4
    },
    {
        img: injecaoPlastico5
    },
    {
        img: injecaoPlastico6
    },
]






const InjecaoPlasticoPage = () => {
return (
    <div>
        <Header/>
            <ImgInjecaoPlastico
                listaInjecaoPlastico = {listaInjecaoPlastico}
            />
    </div>
)
}

export default InjecaoPlasticoPage